import React  from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import "./index.scss";

import ThirdPartyVendors from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/ThirdPartyVendor";
import VendorRiskVsBusinessImpact from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/VendorRiskVsBusinessImpact";
import VendorScoreChange from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/VendorScoreChange";
import VendorOverview from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/VendorOverview";
import VendorRisk from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/VendorRisk";
// import CyberHealthCare from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/CyberHealthCare";
// import TopIssuesList from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/TopIssueList";
// import MostCommonIssue from "../../../../components/PostLogin/ScanInfo/ThirdPartyRisk/DashboardOverview/MostCommonIssues";



import { useScanInfoContext } from "../../../ScanInfo/ScanInfoContext";

const DashboardOverview = () => {

    const { customerId } = useScanInfoContext();

    return (
        <>
            <div className="dashboard-risk-main-content">
                <Row>
                    <Col lg={4}>
                       <ThirdPartyVendors customerId={customerId} />
                       
                    </Col>
                    <Col lg={8}>
                        <VendorRiskVsBusinessImpact customerId={customerId}/>
                    </Col>
                </Row>
            </div>
            <VendorScoreChange customerId={customerId}/>
            <VendorOverview customerId={customerId}/>
            <VendorRisk customerId={customerId}/>

            {/* for future 
            <CyberHealthCare />
            <MostCommonIssue />
            <TopIssuesList /> */}
        </>

    )
}


export default DashboardOverview;